import React, { useContext } from 'react';
import { Card, CardHeader, CardBody } from '@progress/kendo-react-layout';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import { Icon, SvgIcon } from '@progress/kendo-react-common';
import { Link, useNavigate } from 'react-router-dom';
import { RevUserContext } from '../../../../context/UserContext';
import { IUserProfile } from '../../../../types/User/IUserProfile';
import { Button, DropDownButton, DropDownButtonItem, DropDownButtonItemClickEvent, SplitButton } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { Align } from '@progress/kendo-react-popup';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { toast } from 'react-toastify';
import { ReassignProps } from '../../../../types/Props/ReassignProps';
import { PartialSpinny } from '../../../Nav/Spinny';
import { Skeleton } from '@progress/kendo-react-indicators';
import Allocation from '../../../Gameplan/Allocation';

const Ownership: React.FC<ITicketProps> = (ticket) => {
    const navigate = useNavigate();
    const profile = useContext<IUserProfile>(RevUserContext)
    const [opened, setOpened] = React.useState(false);
    const [reassignTicket, { isLoading: saving }] = TicketApi.useReassignMutation();

    const menuItemClicked = (e: DropDownButtonItemClickEvent) => {
        console.log('menu item clicked', e);
        if (e.item.text === 'Edit') {
            navigate('ownership');
        } else if (e.item.text === 'Add Me') {
            reassignTicket({ TicketId: ticket.ID, New_Assignees: [profile.Id], Add_To_Existing: true } as ReassignProps).unwrap().then(() => {
                //overkill
                //toast.success(`You have been assigned to this ${profile?.Phrases.CallPhrase}`);
            }).catch((e) => {
                toast.error('Failed to assign you to this ticket: ' + e.error);
            });
        } else if (e.item.text === 'Own') {
            reassignTicket({ TicketId: ticket.ID, New_Assignees: [profile.Id], Add_To_Existing: false } as ReassignProps).unwrap().then(() => {
                //overkill
                //toast.success(`You have been assigned to this ${profile?.Phrases.CallPhrase}`);
            }).catch((e) => {
                toast.error('Failed to assign you to this ticket: ' + e.error);
            });
        }
    }

    if (profile?.Features.External_Interface || ticket.Is_Workstream) return null;

    return (
        <Card className="ownership">
            <CardHeader>
                <i><SvgIcon size='large' icon={svg.userOutlineIcon} className='mr-2' ></SvgIcon></i>
                <Link className='nav-link ownership-link' to='ownership' title='Edit ownership'>Ownership<SvgIcon icon={svg.hyperlinkOpenIcon} className='d-none' /> </Link>
                <i className='ownership-menu-button123'>
                    <DropDownButton fillMode='flat' onItemClick={menuItemClicked} svgIcon={svg.moreVerticalIcon} popupSettings={{ animate: false, popupClass: 'ownership-menu', popupAlign: { horizontal: 'right' } as Align }}>
                        <DropDownButtonItem svgIcon={svg.pencilIcon} text="Edit" />
                        <DropDownButtonItem svgIcon={svg.plusOutlineIcon} text="Add Me" disabled={ticket?.Call_Assignment?.find(ass => ass.Contact_Id == profile.Id) != null} />
                        <DropDownButtonItem svgIcon={svg.userOutlineIcon} text="Own" disabled={ticket?.Call_Assignment?.find(ass => ass.Contact_Id == profile.Id) != null && ticket?.Call_Assignment.length == 1} />
                    </DropDownButton>

                </i>
            </CardHeader>
            <CardBody>
                {ticket.Is_Loading ? <Skeleton shape="rectangle" style={{ width: '100%', height: '50px', marginTop: '2px' }} /> :
                    <>{saving ? <PartialSpinny /> :
                        <div className='info'>
                            <div className='g'>Logged By</div><div className='t'><Link to={`/contacts/contactinfo.aspx?contact_Id=${ticket.Call_Opener}`}>{ticket.Call_Opener_Name}</Link></div>
                            <div className='g'>Assigned To</div><div className='t'> {ticket?.Call_Assignment?.map((ass, index) => <div className='b' key={index}>{ass.Contact_Name}</div>)}</div>
                        </div>
                    }</>
                }
            </CardBody>
        </Card>
    );
};

export default Ownership;